import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class CmsContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
      const content = JSON.parse(localStorage.getItem("pagecontents"));
      const abudhabi = JSON.parse(localStorage.getItem("abudhabi"));
      console.log(abudhabi);
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
         
          {this.props.content.slug === "diversity-strategy-2030" && 
          
          <section class="section-padded diversity "><div class="stat-section">
          <div className="page-stat-content">

  {content
    .filter(item => item.id >= 7 && item.id <= 16)
    .map((item, index) => (
  <div className="stat-item" data-aos="fade-up" data-aos-delay="0">
    <div className="stat-number">
      {item.title}
    </div>
    <div className="stat-desc">{item.subtitle}</div>
    <p className="stat-sub"><div  dangerouslySetInnerHTML={{ __html: item.description}} /> </p>
  </div>
    ))}
</div>
</div></section>
          }
            
             <section className="section-padded">
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          className={this.props.content.slug === "how-we-do-it" || this.props.content.slug === "abudhabi" ? "content aos-init" :"content two-columns  aos-init"}
        >

           {this.props.content.slug === "abudhabi" && 
<h1>{ this.props.content.title}</h1>
    }
          
           <div  dangerouslySetInnerHTML={{ __html: this.props.content.description}} />  
        </div>
      </section>


         {this.props.content.slug === "key-figures" && 
          
          <section class="section-padded diversity "><div class="stat-section">
          <div className="page-stat-content">

  {content
    .filter(item => item.id >= 17  )
    .map((item, index) => (
  <div className="stat-item" data-aos="fade-up" data-aos-delay="0">
    <div className="stat-number" style={{fontSize:"50px", marginBottom:"20px" }}>
      {item.title}
    </div>
    <div className="stat-desc">{item.subtitle}</div>
    <p className="stat-sub"><div  dangerouslySetInnerHTML={{ __html: item.description}} /> </p>
  </div>
    ))}
</div>
</div></section>
          }
             

             

         {this.props.content.slug === "abudhabi" && 
          
          <section class="section-padded "> 
          <div className="content">

  {abudhabi.map((item, index) => (
      <div>
 <figure class="image aos-init aos-animate" data-aos="fade-up" data-aos-duration="750">
  <img src={item.image} alt={item.title}  width="100%" />
  </figure>
  <h1 data-aos="fade-up" data-aos-duration="750" class="aos-init aos-animate">{item.title}</h1>
  <p
  data-aos="fade-up"
  data-aos-duration="750"
  className="aos-init aos-animate"
  dangerouslySetInnerHTML={{ __html: item.description }}
></p>

 </div>
    ))}
 
</div></section>
          }
             

           
  
        </div>
       

    );
 
    }
}

export default CmsContent;